module.exports = __webpack_public_path__ + "assets/img/page-header-small.9212bbbf.jpg";